import Quill from 'quill';
import { getVarPlaceholderLabel } from '../../email-system/helpers/outOfOffice';

const Embed = Quill.import('blots/embed');

/**
 * Atomic `%%startDate%%` / `%%endDate%%` chip for the out of office body
 * editor, rendered like the chips in the subject field (VariableTextField).
 *
 * Registering it is safe for every other editor: a blot only materialises when
 * a delta actually contains an `oooVar` insert or pasted HTML carries a
 * `.ooo-chip[data-var]` span — content only the out of office form produces.
 *
 * The delta value is just the variable key. The visible label is cosmetic
 * (resolved date or `[Start date]`) and is rewritten by the form whenever the
 * dates change; the stored form value always keeps the raw `%%key%%` token.
 */
class OutOfOfficeVarBlot extends Embed {
  static blotName = 'oooVar';
  static tagName = 'SPAN';
  static className = 'ooo-chip';

  static create(value) {
    const key = typeof value === 'object' && value !== null ? value.key : value;
    const node = super.create(key);
    node.dataset.var = key;
    // Placeholder label only — Quill's Embed moves this into its guarded
    // content node, where the form relabels it with the resolved date.
    node.textContent = getVarPlaceholderLabel(key);
    return node;
  }

  static value(node) {
    return node.dataset.var;
  }
}

Quill.register(OutOfOfficeVarBlot, true);

export default OutOfOfficeVarBlot;
